import { render } from "./FeedbackFollow.vue?vue&type=template&id=97ffc832"
import script from "./FeedbackFollow.vue?vue&type=script&lang=js"
export * from "./FeedbackFollow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__